import React, { createContext, useContext } from 'react';
import { useTransitionOrchestrator as useTransitionOrchestratorHook } from './TransitionOrchestrator';
import { usePanelSystem } from './PanelContext';
import { PanelState } from './PanelTypes';
import { TransitionOrchestratorContextType } from './shared-types';

// Create the context with a default value
const TransitionOrchestratorContext = createContext<TransitionOrchestratorContextType | undefined>(undefined);

// Provider component
export function TransitionOrchestratorProvider({ children }: { children: React.ReactNode }) {
  // Get the panel context
  const panelContext = usePanelSystem();
  
  // Use the orchestrator hook with the panel context
  const orchestrator = useTransitionOrchestratorHook(panelContext);
  
  // Create the context value
  const contextValue: TransitionOrchestratorContextType = {
    executeTransition: orchestrator.executeTransition,
    cancelAllTransitions: orchestrator.cancelAllTransitions,
    isProcessing: orchestrator.isProcessing,
    activeSequenceId: orchestrator.activeSequenceId
  };
  
  return (
    <TransitionOrchestratorContext.Provider value={contextValue}>
      {children}
    </TransitionOrchestratorContext.Provider>
  );
}

// Hook to use the context
export function useTransitionOrchestrator() {
  const context = useContext(TransitionOrchestratorContext);
  
  if (context === undefined) {
    throw new Error('useTransitionOrchestrator must be used within a TransitionOrchestratorProvider');
  }
  
  return context;
}